// extracted by mini-css-extract-plugin
module.exports = {"about":"about___3n336","about_info":"about_info___3unsW","editor":"editor___Fvk6y","link":"link___1Q0Rb"};